import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { GetClientCommentsByVendorPayload } from "../../payload/GetClientCommentsByVendor/GetClientCommentsByVendorPayload";

const getCommentsByVendorFetch = (state: ClientsState, actions: PayloadAction<GetClientCommentsByVendorPayload>) => {
    state.isLoading = true;
}

export default getCommentsByVendorFetch;